<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="4"
      >
        <b-button
          block
          variant="gradient-success"
          size="lg"
          :disabled="selected === 'bank'"
          @click="setType('bank')"
        >
          <FeatherIcon
            icon="ShieldIcon"
            size="24"
          />
          Banka Havalesi
        </b-button>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-button
          variant="gradient-success"
          size="lg"
          block
          :disabled="selected === 'safe'"
          @click="setType('safe')"
        >
          <FeatherIcon
            icon="InboxIcon"
            size="24"
          />
          Elden Nakit
        </b-button>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-button
          variant="gradient-warning"
          size="lg"
          block
          :disabled="selected === 'return'"
          @click="setType('return')"
        >
          <FeatherIcon
            icon="XCircleIcon"
            size="24"
          />
          Çek İadesi
        </b-button>
      </b-col>
      <b-col
        cols="12"
      >
        <template v-if="selected === 'safe'">
          <hr>
          <donation-groups />
          <safe-accounts />
          <donate-date />
          <amount />
          <receipt />
          <receipt-no v-if="dataItem.is_receipt === '1'" />
          <notes-text />
        </template>
        <template v-if="selected === 'bank'">
          <hr>
          <donation-groups />
          <bank-accounts />
          <donate-date />
          <amount />
          <notes-text />
        </template>
        <template v-if="selected === 'return'">
          <hr>
          <return-notes />
        </template>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {
  BButton, BCard, BCol, BRow,
} from 'bootstrap-vue'
import NotesText from '@/views/Admin/Account_activities/Incomes/elements/Notes.vue'
import Amount from '@/views/Admin/Account_activities/Incomes/elements/Amount.vue'
import DonateDate from '@/views/Admin/Account_activities/Incomes/elements/DonateDate.vue'
import DonationGroups from '@/views/Admin/Account_activities/Incomes/elements/DonationGroups.vue'
import SafeAccounts from '@/views/Admin/Account_activities/Incomes/elements/SafeAccounts.vue'
import ReceiptNo from '@/views/Admin/Account_activities/Incomes/elements/Receipt_no.vue'
import Receipt from '@/views/Admin/Account_activities/Incomes/elements/Receipt.vue'
import BankAccounts from '@/views/Admin/Account_activities/Incomes/elements/BankAccounts.vue'
import ReturnNotes from '@/views/Admin/Promissories/View/LineForm/ReturnNotes.vue'

export default {
  name: 'LineForm',
  components: {
    BankAccounts,
    Receipt,
    ReceiptNo,
    SafeAccounts,
    DonationGroups,
    DonateDate,
    Amount,
    NotesText,
    ReturnNotes,
    BRow,
    BCol,
    BButton,
    BCard,
  },
  data() {
    return {
      selected: 'bank',
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
    promissory() {
      return this.$store.getters['promissories/dataItem']
    },
  },
  methods: {
    setType(type) {
      this.$store.commit('accountActivities/RESET_DATA_ITEM')
      this.promissory.is_return = null
      this.promissory.return_notes = null
      if (type === 'return') {
        this.promissory.is_return = 1
        this.promissory.id_promissory_statuses = 3
      } else {
        this.dataItem.is_receipt = '1'
        this.dataItem.id_promissory_statuses = '2'
      }
      this.selected = type
    },
  },
}
</script>
